import HtmlCode from "../../../../../app/components/HtmlCode.jsx";

export default function ReactScriptTile({ tile }) {
  return <HtmlCode content={tile.script} />;
}
